import { OperationAuditModel } from '../operation-audit-model';

export class MicrosoftOfficeOperationAuditContextModel extends OperationAuditModel {
  providerPolicy: string;
}
